var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataReady)?_c('div',{attrs:{"id":_vm.id}},[_vm._t("default")],2):_c('Spinner')}
var staticRenderFns = []

export { render, staticRenderFns }